// extracted by mini-css-extract-plugin
export default {"dataBlock":"GuestForm_dataBlock__hgOCq","item":"GuestForm_item__GxtOC","row":"GuestForm_row__E8JXT","checkbox":"GuestForm_checkbox__u+fvm"};